import React from 'react';
import Layout from '../Shared/Layout';
import {Container, Grid, Paper} from "@material-ui/core";
import styled from "styled-components";
import Add from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import ReorderIcon from '@material-ui/icons/Reorder';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import SettingsIcon from '@material-ui/icons/Settings';
import PolicyIcon from '@mui/icons-material/Policy';
import {InertiaLink} from "@inertiajs/inertia-react";
import DescriptionIcon from '@material-ui/icons/Description';
import { Trans } from "../utils/i18n";
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import {EnergySavingsLeaf} from "@mui/icons-material";
import AccordionList from "../Shared/AccordionList";

const Card = styled(InertiaLink)`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  text-align: center;
  padding: 30px;
  font-size: 20px;
  display: block;
  text-decoration: none;
  color: ${props => props.theme.text};
  height: 100%;
`;
const CardA = styled.a`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  text-align: center;
  padding: 30px;
  font-size: 20px;
  display: block;
  text-decoration: none;
  color: ${props => props.theme.text};
  height: 100%;
`;

const Wrapper = styled.div`
`;

const Title = styled.h2`
    color: ${props => props.theme.primary};
`;

export default function Dashboard({ user, permissions, client, faqs = [] }) {
    return (
        <Wrapper>
            <div className={"mb-12"}>
                <Container maxWidth="lg">
                    <Grid container spacing={3} justify={"center"}>
                        {client.key === "b2x_carbon" && (
                            <Grid item xs={12} sm={3}>
                                <Card href={route("emissions.enterprise")}>
                                    <EnergySavingsLeaf
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="emissions.co2CalcEnterprise">
                                            CO2e Calculator for Enterprise
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="emissions.co2Calc.description">
                                            Calculate the CO2e emissions of your
                                            device repair.
                                        </Trans>
                                    </p>
                                </Card>
                            </Grid>
                        )}
                        {(["admin"].includes(user.role) ||
                            permissions.includes("order") ||
                            permissions.includes("order_create")) && (
                            <Grid item xs={12} sm={3}>
                                <Card href={route("order")}>
                                    <Add
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.orderEntry">
                                            Order Entry
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.orderEntry.description">
                                            Create an order for your service
                                            request.
                                        </Trans>
                                    </p>
                                </Card>
                            </Grid>
                        )}
                        {(["admin"].includes(user.role) ||
                            permissions.includes("shop")) && (
                            <Grid item xs={12} sm={3}>
                                <Card href={route("partsshop.index")}>
                                    <Add
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.shop">
                                            Buy Parts
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.shop.description">
                                            Create a purchase order for parts.
                                        </Trans>
                                    </p>
                                </Card>
                            </Grid>
                        )}
                        {(["admin"].includes(user.role) ||
                            permissions.includes("track")) && (
                            <Grid item xs={12} sm={3}>
                                <Card href={route("track.index")}>
                                    <SearchIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.trackTrace">
                                            Track & Trace
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.trackTrace.description">
                                            Track a created order and get the
                                            latest status and additional
                                            information.
                                        </Trans>
                                    </p>
                                </Card>
                            </Grid>
                        )}
                        {(["admin"].includes(user.role) ||
                            permissions.includes("returnservice")) && (
                            <Grid item xs={12} sm={3}>
                                <Card href={route("returnservice.form")}>
                                    <LocalShippingIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.returnService">
                                            Return Service
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.returnService.description">
                                            Book a return parcel to your order
                                        </Trans>
                                    </p>
                                </Card>
                            </Grid>
                        )}
                        {(["admin"].includes(user.role) ||
                            permissions.includes("warrantyCheck")) && (
                            <Grid item xs={12} sm={3}>
                                <Card href={route("warranty.index")}>
                                    <PolicyIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="warrantyCheck.title">
                                            Warranty Check
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.warrantyCheck.description">
                                            Check the warranty status of your
                                            device
                                        </Trans>
                                    </p>
                                </Card>
                            </Grid>
                        )}
                        {(["admin"].includes(user.role) ||
                            permissions.includes("queue") ||
                            permissions.includes("order_viewany")) && (
                            <Grid item xs={12} sm={3}>
                                <Card href={route("queue.index")}>
                                    <ReorderIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.queues">
                                            Queues
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.queues.description">
                                            Lorem ipsum dolor sit amet,
                                            consetetur sadipscing elitr, sed
                                            diam nonumy eirmod tempor invidunt
                                            ut labore et dolore magna aliquyam
                                            erat, sed diam voluptua.
                                        </Trans>
                                    </p>
                                </Card>
                            </Grid>
                        )}
                        {(["admin", "converter"].includes(user.role) ||
                            permissions.includes("report") ||
                            permissions.includes("report_viewany")) && (
                            <Grid item xs={12} sm={3}>
                                <Card href={route("report.redirect")}>
                                    <DescriptionIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.reports">
                                            Reports
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.reports.description">
                                            Run an Report
                                        </Trans>
                                    </p>
                                </Card>
                            </Grid>
                        )}
                        {(["admin"].includes(user.role) ||
                            permissions.includes("analytics")) && (
                            <Grid item xs={12} sm={3}>
                                <Card href={route("admin.analytics-overview")}>
                                    <ShowChartIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.analytics">
                                            Analytics
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.analytics.description">
                                            Lorem ipsum dolor sit amet,
                                            consetetur sadipscing elitr, sed
                                            diam nonumy eirmod tempor invidunt
                                            ut labore et dolore magna aliquyam
                                            erat, sed diam voluptua.
                                        </Trans>
                                    </p>
                                </Card>
                            </Grid>
                        )}
                        {(["admin", "manager"].includes(user.role) ||
                            permissions.includes("nova")) && (
                            <Grid item xs={12} sm={3}>
                                <Card href="/nova">
                                    <AdminPanelSettingsIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.nova">
                                            Nova
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.nova.description">
                                            Access the B2X Administrative
                                            Backend.
                                        </Trans>
                                    </p>
                                </Card>
                            </Grid>
                        )}
                        {(["converter"].includes(user.role) ||
                            permissions.includes("converter")) && (
                            <Grid item xs={12} sm={3}>
                                <Card href={route("convert.redirect")}>
                                    <FileCopyIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.fileHelper">
                                            File Helper
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.fileHelper.description">
                                            Convert an Order file into a B2X ONE
                                            Service OS Sale Order file format
                                        </Trans>
                                    </p>
                                </Card>
                            </Grid>
                        )}
                        {permissions.includes("convert_waybillchecker") && (
                            <Grid item xs={12} sm={3}>
                                <Card
                                    href={route(
                                        "convert.waybillcheckerredirect"
                                    )}
                                >
                                    <FileCopyIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.waybillchecker">
                                            Waybill Checker
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.waybillchecker.description">
                                            Check tracking numbers against
                                            ONE-Connect and ONE-OS
                                        </Trans>
                                    </p>
                                </Card>
                            </Grid>
                        )}
                        {permissions.includes("api_docs_defaultv1_view") && (
                            <Grid item xs={12} sm={3}>
                                <CardA
                                    target={"_blank"}
                                    href={route("l5-swagger.defaultv1.api")}
                                >
                                    <SettingsIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.apiDocsDefaultV1">
                                            Default API Documentation
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.apiDocsDefaultV1.description">
                                            Read the OpenAPI compatible API
                                            Documentation
                                        </Trans>
                                    </p>
                                </CardA>
                            </Grid>
                        )}
                        {permissions.includes("api_docs_defaultv2_view") && (
                            <Grid item xs={12} sm={3}>
                                <CardA
                                    target={"_blank"}
                                    href={route("l5-swagger.defaultv2.api")}
                                >
                                    <SettingsIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.apiDocsDefaultV2">
                                            Default API V2 Documentation
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.apiDocsDefaultV2.description">
                                            Read the OpenAPI compatible API
                                            Documentation
                                        </Trans>
                                    </p>
                                </CardA>
                            </Grid>
                        )}
                        {permissions.includes("api_docs_worldpayv1_view") && (
                            <Grid item xs={12} sm={3}>
                                <CardA
                                    target={"_blank"}
                                    href={route("l5-swagger.worldpayv1.api")}
                                >
                                    <SettingsIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.apiDocsWorldpayV1">
                                            Worldpay API Documentation
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.apiDocsWorldpayV1.description">
                                            Read the OpenAPI compatible API
                                            Documentation for Worldpay
                                        </Trans>
                                    </p>
                                </CardA>
                            </Grid>
                        )}
                        {permissions.includes("api_docs_amazonv1_view") && (
                            <Grid item xs={12} sm={3}>
                                <CardA
                                    target={"_blank"}
                                    href={route("l5-swagger.amazonv1.api")}
                                >
                                    <SettingsIcon
                                        style={{ fontSize: 50 }}
                                        color={"secondary"}
                                    />
                                    <Title>
                                        <Trans i18nKey="dashboard.apiDocsAmazonV1">
                                            Amazon API Documentation
                                        </Trans>
                                    </Title>
                                    <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="dashboard.apiDocsAmazonV1.description">
                                            Read the OpenAPI compatible API
                                            Documentation for Amazon
                                        </Trans>
                                    </p>
                                </CardA>
                            </Grid>
                        )}
                    </Grid>
                </Container>
            </div>

            {permissions.includes("faq_viewany") && (
                <>
                    {faqs.length > 0 && (
                        <div className={"mb-12"}>
                            <Container maxWidth="lg">
                                <div className="max-w-4xl mx-auto flex flex-col items-center mt-32 mb-16 rounded  shadow-lg bg-[#fff] p-4">
                                    <>
                                        <h2
                                            className={
                                                "text-center text-2xl font-bold mb-0 mt-8"
                                            }
                                        >
                                            <Trans i18nKey={"welcome.faq.title"}>
                                                FAQs & Troubleshooting Guides
                                            </Trans>
                                        </h2>
                                        <p
                                            className={
                                                "text-center text-md font-medium mt-4"
                                            }
                                        >
                                            <Trans i18nKey={"welcome.faq.subtitle"}>
                                                All you need to know about our service
                                                offer
                                            </Trans>
                                        </p>
                                        <div className="w-11/12">
                                            <AccordionList items={faqs} />
                                        </div>
                                    </>
                                    <p className={"text-center mt-3 mb-8 pt-8"}>
                                        <InertiaLink
                                            className={
                                                " block font-bold text-secondary"
                                            }
                                            href={route("faq")}
                                        >
                                            <Trans
                                                i18nKey={"welcome.checkAllResources"}
                                            >
                                                Check all the resources
                                            </Trans>
                                        </InertiaLink>
                                    </p>
                                </div>
                            </Container>
                        </div>
                    )}
                </>
            )}
        </Wrapper>
    );
}

Dashboard.layout = page => <Layout children={page} />;
